import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Form, DatePicker, InputNumber, message } from 'antd'
import moment from 'moment'
import numeral from 'numeral'
import { actions } from '../../../redux/modules/jobFunctions/jobFinancialSummaryActions'
import Loader from '../../common/Loader'
import _ from 'lodash'

const FormItem = Form.Item
const propTypes = {}

function validateDate(date) {
  if (date === null) {
    return null
  }
  if (moment.isMoment(date)) {
    return date.format('YYYY-MM-DD hh:mm:ss')
  }
  return date
}
class JobFinancialSummary extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditing: false
    }

    this.props.getJobFinancialSummary({
      jobId: this.props.jobId
    })
  }

  handleEditDateClick = () => {
    this.setState({
      isEditing: true
    })
  }

  handleCancelEditClick = () => {
    this.setState({
      isEditing: false
    })
  }

  handleSaveDatesClick = () => {
    const form = this.props.form

    form.validateFields((err, values) => {
      if (err) {
        return
      }

      let transformedDates = {}
      Object.keys(values).forEach(function(key, value) {
        transformedDates[key] = validateDate(values[key])
      })
      this.props.updateJobFinancialSummary({
        jobId: this.props.jobId,
        userId: this.props.user.userId,
        content: transformedDates
      })

      form.resetFields()
      this.setState({ contentData: null, currentId: 0, modalVisible: false })
    })
    this.setState({
      isEditing: false
    })
  }

  handleNotesBlur = e => {
    this.props.updateNotes({
      jobId: this.props.jobId,
      userId: this.props.user.userId,
      notes: e.target.value
    })
    message.success('Notes saved.')
  }

  render() {
    const { jobFinancialSummary } = this.props.jobFinancialSummary
    const { getFieldDecorator } = this.props.form
    const aiaDueDay = _.get(
      this.props,
      'jobFinancialSummary.jobFinancialSummary.collection.data.aia_due_day'
    )

    const netChanges = _.get(
      this.props,
      'jobFinancialSummary.jobFinancialSummary.collection.net_changes'
    )

    const baseContractTotal = _.get(
      this.props,
      'jobFinancialSummary.jobFinancialSummary.collection.data.base_contract_total'
    )

    const expectedPayDay = _.get(
      this.props,
      'jobFinancialSummary.jobFinancialSummary.collection.data.aia_expected_pay_day'
    )

    const executedContractDate = _.get(
      this.props,
      'jobFinancialSummary.jobFinancialSummary.collection.data.executed_contract_date'
    )

    const montlyContractTotal = _.get(
      this.props,
      'jobFinancialSummary.jobFinancialSummary.collection.monthly_contract_total'
    )

    const contractExpirationDate = _.get(
      this.props,
      'jobFinancialSummary.jobFinancialSummary.collection.contract_expiration_date'
    )

    const monthlyInvoiceDay = _.get(
      this.props,
      'jobFinancialSummary.jobFinancialSummary.collection.monthly_invoice_day'
    )

    const jobType = _.get(this.props, 'match.params.jobType')

    if (!jobFinancialSummary) {
      return <Loader />
    }
    return (
      <div>
        <div className="jobsBar">
          Financial Summary
          {!this.state.isEditing && (
            <div className="jobsBarAdd" onClick={() => this.handleEditDateClick()}>
              <i className="fa fa-pencil-square" aria-hidden="true" />
              &nbsp;<div className="addJobLabel">EDIT Dates</div>
            </div>
          )}
          {this.state.isEditing && (
            <div className="displayFlex">
              <div className="jobsBarAdd" onClick={() => this.handleSaveDatesClick()}>
                <i className="fa fa-save" aria-hidden="true" />
                &nbsp;<div className="addJobLabel">SAVE CHANGES</div>
              </div>
              <div className="jobsBarAdd" onClick={() => this.handleCancelEditClick()}>
                <i className="fa fa-ban" aria-hidden="true" />
                &nbsp;<div className="addJobLabel">CANCEL</div>
              </div>
            </div>
          )}
        </div>
        <Form layout="vertical">
          {this.props.jobFinancialSummary &&
            jobType !== 'Maintenance-Service' && (
              <div className="row padding20">
                <div className="col-xs-12 col-md-6">
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">Base Contract Total</div>
                    {this.state.isEditing && (
                      <FormItem>
                        {getFieldDecorator('base_contract_total', {
                          initialValue: baseContractTotal
                        })(
                          <InputNumber
                            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                          />
                        )}
                      </FormItem>
                    )}
                    {!this.state.isEditing && (
                      <div>{numeral(baseContractTotal).format('$0,0.00')}</div>
                    )}
                  </div>
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">Net Changes</div>
                    <div>{numeral(netChanges).format('$0,0.00')}</div>
                  </div>
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">Job Total</div>
                    <div>{numeral(baseContractTotal + netChanges).format('$0,0.00')}</div>
                  </div>
                </div>
                <div className="col-xs-12 col-md-6">
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">Executed Contract</div>
                    {this.state.isEditing && (
                      <FormItem>
                        {getFieldDecorator('executed_contract_date', {
                          initialValue: moment(executedContractDate).isValid()
                            ? moment(executedContractDate)
                            : null
                        })(<DatePicker />)}
                      </FormItem>
                    )}
                    {!this.state.isEditing && (
                      <div>
                        {executedContractDate !== null
                          ? moment(executedContractDate).format('M/D/YYYY')
                          : 'Not Entered'}
                      </div>
                    )}
                  </div>
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">AIA Due Day</div>
                    {this.state.isEditing && (
                      <FormItem>
                        {getFieldDecorator('aia_due_day', {
                          initialValue: aiaDueDay
                        })(<InputNumber />)}
                      </FormItem>
                    )}
                    {!this.state.isEditing && (
                      <div>{aiaDueDay !== null ? aiaDueDay : 'Not Entered'}</div>
                    )}
                  </div>
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">AIA Expected Pay Day</div>
                    {this.state.isEditing && (
                      <FormItem>
                        {getFieldDecorator('aia_expected_pay_day', {
                          initialValue: expectedPayDay
                        })(<InputNumber />)}
                      </FormItem>
                    )}
                    {!this.state.isEditing && (
                      <div>{expectedPayDay !== null ? expectedPayDay : 'Not Entered'}</div>
                    )}
                  </div>
                </div>
              </div>
            )}
          {this.props.jobFinancialSummary &&
            jobType === 'Maintenance-Service' && (
              <div className="row padding20">
                <div className="col-xs-12 col-md-12">
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">Monthly Contract Total</div>
                    {this.state.isEditing && (
                      <FormItem>
                        {getFieldDecorator('monthly_contract_total', {
                          initialValue: montlyContractTotal
                        })(
                          <InputNumber
                            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                          />
                        )}
                      </FormItem>
                    )}
                    {!this.state.isEditing && (
                      <div>{numeral(montlyContractTotal).format('$0,0.00')}</div>
                    )}
                  </div>
                </div>
                <div className="col-xs-12 col-md-12">
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">Contract Expiration</div>
                    {this.state.isEditing && (
                      <FormItem>
                        {getFieldDecorator('contract_expiration_date', {
                          initialValue: moment(contractExpirationDate).isValid()
                            ? moment(contractExpirationDate)
                            : null
                        })(<DatePicker />)}
                      </FormItem>
                    )}
                    {!this.state.isEditing && (
                      <div>
                        {contractExpirationDate !== null
                          ? moment(contractExpirationDate).format('M/D/YYYY')
                          : 'Not Entered'}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-xs-12 col-md-12">
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">Monthly Invoice Day</div>
                    {this.state.isEditing && (
                      <FormItem>
                        {getFieldDecorator('monthly_invoice_day', {
                          initialValue: monthlyInvoiceDay
                        })(<InputNumber />)}
                      </FormItem>
                    )}
                    {!this.state.isEditing && (
                      <div>{monthlyInvoiceDay ? monthlyInvoiceDay : 'Not Entered'}</div>
                    )}
                  </div>
                </div>
              </div>
            )}
        </Form>
      </div>
    )
  }
}

const mapStateToProps = ({ jobFinancialSummary }, ownProps) => ({
  jobFinancialSummary
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(actions, dispatch)
})

JobFinancialSummary.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobFinancialSummary))
)



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobFinancialSummary.js